import { NAME as PARENT_NAME } from '../constants';

export const NAME = `${PARENT_NAME}/ADDRESS`;

export const ROUTES = {
  ROOT: '/shipment/update-address/:shipmentId?',
  RECEPIENT: '/shipment/update-recipient/:shipmentId',
};

export const UPDATE_RECEPIENT_FORM = 'UPDATE_RECEPIENT';
export const UPDATE_ADDRESS_URL = `${SHIPPING_EDGE}/public-api/shipments/update-draft-shipment`;
export const UPDATE_RECEPIENT_URL = `${SHIPPING_EDGE}/api/waybills/<%= waybill %>/updates`;
export const UPDATE_ADDRESS_FORM = 'UPDATE_ADDRESS';
